// extracted by mini-css-extract-plugin
export default {"sticky_nav":"ToolBarPaginas_sticky_nav__XHt67"};